import { Theme } from '@/utils/constants';
import clsx from 'clsx';
import React, { memo, PropsWithChildren } from 'react';
import { MuiTypography } from '../material-ui';
import { TwoColumnContentProps } from './TwoColumnContent.interface';
import useStyles from './TwoColumnContent.styles';

const TwoColumnContent = ({
  title,
  columnRatio = '50-50',
  leftColumn,
  rightColumn,
  className,
  theme = Theme.light,
}: PropsWithChildren<TwoColumnContentProps>) => {
  const classes = useStyles({});

  const leftColumnClassName = clsx(
    classes.leftColumn,
    `ar-${columnRatio}`,
    'column',
    'left-column',
  );
  const rightColumnClassName = clsx(
    classes.rightColumn,
    `ar-${columnRatio}`,
    'column',
    'right-column',
  );
  const titleClassName = clsx(classes.title, `${theme}-theme`);

  return (
    <div data-testid="qa-two-col-content" className={clsx(classes.root, className)}>
      {title && (
        <MuiTypography variant="overline" component="h2" className={titleClassName}>
          {title}
        </MuiTypography>
      )}

      {(leftColumn || rightColumn) && (
        <div className={clsx(classes.columns, 'columns')}>
          {leftColumn && <div className={leftColumnClassName}>{leftColumn}</div>}
          {rightColumn && <div className={rightColumnClassName}>{rightColumn}</div>}
        </div>
      )}
    </div>
  );
};

export default memo(TwoColumnContent);
